export default __webpack_public_path__ + "static/media/services2.b278606a.png";